// import React, { useEffect, useState } from "react";

// import { useNavigate } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import { DataGrid, GridColumnMenu, GridToolbar } from '@mui/x-data-grid';
// import Loader from "../../components/common/Loader";
// import Badge from '@mui/material/Badge';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import Button from '@mui/material/Button';

// import { green, yellow, red, deepPurple } from '@mui/material/colors';
// import { SERVER_ORIGIN } from "../../utilities/constants";
// import { hasReadOnlyAccess, getDashboardPath } from "../../utilities/helper_functions";
// import HeaderCard from "../../components/common/HeaderCard";
// import BackButton from "../../components/common/BackButton";

// import css from "../../css/admin/users-page.module.css";

// const AllRegionEM = () => {
//     const [isLoading, setIsLoading] = useState(false);
//     const [limit, setLimit] = useState(0);
//     const [allRegionEMs, setAllRegionEMs] = useState([]);
//     const [page, setPage] = useState(1);
//     const [sortType, setSortType] = useState(true);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [totalPages, setTotalPages] = useState(0);

//     // Dialog states
//     const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//     const [openReinviteDialog, setOpenReinviteDialog] = useState(false);
//     const [selectedId, setSelectedId] = useState(null);
//     const [selectedOnboardingStatus, setSelectedOnboardingStatus] = useState('');

//     const navigate = useNavigate();

//     useEffect(() => {
//         async function getAllRegionEMs() {
//             setIsLoading(true);

//             try {
//                 const response = await fetch(
//                     `${SERVER_ORIGIN}/api/regionem/auth/all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"}`,
//                     {
//                         method: "GET",
//                         headers: {
//                             "Content-Type": "application/json",
//                             "auth-token": sessionStorage.getItem("token"),
//                         },
//                     }
//                 );

//                 const result = await response.json();
//                 setIsLoading(false);

//                 if (response.status >= 400 && response.status < 600) {
//                     if (response.status === 401) {
//                         navigate("/admin/login");
//                     } else if (response.status === 500) {
//                         toast.error(result.statusText);
//                     }
//                 } else if (response.status === 200) {
//                     setAllRegionEMs(result.filteredRegionEMs);
//                     setTotalPages(result.totalPages);
//                 }
//             } catch (err) {
//                 setIsLoading(false);
//                 toast.error("Failed to fetch Region EMs");
//             }
//         }

//         getAllRegionEMs();
//     }, [page, sortType, searchQuery, navigate, limit]);

//     const renderOnboardingStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'invited':
//                 statusColor = yellow[500];
//                 statusText = 'Invited';
//                 textColor = "black";
//                 break;
//             case 'pending':
//                 statusColor = deepPurple[500];
//                 statusText = 'Pending';
//                 textColor = "white";
//                 break;
//             case 'onboarded':
//                 statusColor = green[500];
//                 statusText = 'Onboarded';
//                 textColor = "white";
//                 break;
//             default:
//                 statusColor = 'black';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return (
//             <Badge>
//                 <span style={{
//                     backgroundColor: statusColor,
//                     padding: '6.4px 16px',
//                     borderRadius: '8px',
//                     color: textColor
//                 }}>
//                     {statusText}
//                 </span>
//             </Badge>
//         );
//     };

//     const renderEmailStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'sent':
//                 statusColor = green[500];
//                 statusText = 'Sent';
//                 textColor = "white";
//                 break;
//             case 'not sent':
//                 statusColor = red[500];
//                 statusText = 'Not Sent';
//                 textColor = "white";
//                 break;
//             default:
//                 statusColor = 'black';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return (
//             <Badge>
//                 <span style={{
//                     borderRadius: '8px',
//                     backgroundColor: statusColor,
//                     padding: '6.4px 16px',
//                     color: textColor
//                 }}>
//                     {statusText}
//                 </span>
//             </Badge>
//         );
//     };

//     // Dialog handlers
//     const handleDeleteClick = (id) => {
//         setSelectedId(id);
//         setOpenDeleteDialog(true);
//     };

//     const handleReinviteClick = (id, onboardingStatus) => {
//         if (onboardingStatus === 'onboarded') {
//             toast.error("Cannot reinvite an already onboarded user");
//             return;
//         }
//         setSelectedId(id);
//         setSelectedOnboardingStatus(onboardingStatus);
//         setOpenReinviteDialog(true);
//     };

//     const handleDeleteDialogClose = () => {
//         setOpenDeleteDialog(false);
//         setSelectedId(null);
//     };

//     const handleReinviteDialogClose = () => {
//         setOpenReinviteDialog(false);
//         setSelectedId(null);
//         setSelectedOnboardingStatus('');
//     };

//     const handleDeleteConfirm = async () => {
//         try {
//             const response = await fetch(
//                 `${SERVER_ORIGIN}/api/regionem/auth/dlt/${selectedId}`,
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "auth-token": sessionStorage.getItem("token"),
//                     },
//                 }
//             );

//             const result = await response.json();
//             if (response.status === 200) {
//                 toast.success("Region EM deleted successfully");
//                 // Refresh the list
//                 window.location.reload();
//             } else {
//                 toast.error(result.statusText || "Failed to delete Region EM");
//             }
//         } catch (err) {
//             toast.error("Error deleting Region EM");
//         }
//         handleDeleteDialogClose();
//     };

//     const handleReinviteConfirm = async () => {
//         try {
//             const response = await fetch(
//                 `${SERVER_ORIGIN}/api/regionem/auth/reinvite/${selectedId}`,
//                 {
//                     method: "POST",
//                     headers: {
//                         "Content-Type": "application/json",
//                         "auth-token": sessionStorage.getItem("token"),
//                     },
//                 }
//             );

//             const result = await response.json();
//             if (response.status === 200) {
//                 toast.success("Invitation email sent successfully");
//                 // Refresh the list to update status
//                 window.location.reload();
//             } else {
//                 toast.error(result.statusText || "Failed to send invitation");
//             }
//         } catch (err) {
//             toast.error("Error sending invitation");
//         }
//         handleReinviteDialogClose();
//     };

//     const rows = allRegionEMs.map((regionEM, idx) => ({
//         ...regionEM,
//         'id': idx + 1
//     }));

//     const columns = [
//         {
//             field: 'id',
//             headerName: 'ID',
//             width: 90,
//         },
//         {
//             field: 'name',
//             headerName: 'Name',
//             width: 170,
//         },
//         {
//             field: 'email',
//             headerName: 'Email',
//             width: 200,
//         },
//         {
//             field: 'region',
//             headerName: 'Region',
//             width: 150,
//         },
//         {
//             field: 'mobile_no',
//             headerName: 'Mobile Number',
//             width: 150,
//         },
//         {
//             field: 'role',
//             headerName: 'Role',
//             width: 150,
//         },
//         {
//             field: 'emailSentStatus',
//             headerName: 'Email Status',
//             width: 130,
//             renderCell: renderEmailStatus
//         },
//         {
//             field: 'onboardingSatus',
//             headerName: 'Onboarding Status',
//             width: 160,
//             renderCell: renderOnboardingStatus,
//         },

//         {
//             field: 'editDetails',
//             headerName: 'Edit',
//             type: 'actions',
//             width: 150,
//             align: 'center',
//             renderCell: (params) => (
//                 <button
//                     className={css.viewBtn}
//                     onClick={() =>
//                         navigate(
//                             `/region-em/add?edit=true&id=${encodeURIComponent(params.row._id)}`
//                         )
//                     }
//                 >
//                     Edit
//                 </button>
//             )
//         },

//         {
//             headerName: 'Actions',
//             width: 300,
//             renderCell: (params) => {
//                 const isOnboarded = params.row.onboardingSatus === 'onboarded';
//                 const isReadOnly = hasReadOnlyAccess();

//                 if (isReadOnly) {
//                     return (
//                         <div className="d-flex justify-content-center">
//                             <span className="badge bg-secondary">View Only</span>
//                         </div>
//                     );
//                 }

//                 return (
//                     <div className="d-flex justify-content-between">
//                         {/* <button
//                             className="btn btn-sm btn-primary mx-1"
//                             onClick={() => navigate(`/region-em/edit/${params.row._id}`)}
//                         >
//                             Edit
//                         </button> */}
//                         {!isOnboarded && (
//                             <button
//                                 className="btn btn-sm btn-warning mx-1"
//                                 onClick={() => handleReinviteClick(params.row._id, params.row.onboardingSatus)}
//                                 style={{ color: 'white' }}
//                             >
//                                 Reinvite
//                             </button>
//                         )}
//                         <button
//                             className="btn btn-sm btn-danger mx-1"
//                             onClick={() => handleDeleteClick(params.row._id)}
//                         >
//                             Delete
//                         </button>
//                     </div>
//                 );
//             }
//         },
//     ];

//     function handleAddRegionEMClick() {
//         navigate("/region-em/add");
//     }

//     function CustomColumnMenu(props) {
//         return (
//             <GridColumnMenu
//                 {...props}
//                 slots={{}}
//                 slotProps={{}}
//             />
//         );
//     }

//     return (
//         <div className={css.outerDiv}>
//             <HeaderCard>
//                 <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />
//                 <h1 className="headerTitle">Region EMs</h1>
//                 <hr />
//                 {hasReadOnlyAccess() ? (
//                     <div>
//                         <p className="headerSubtitle">
//                             You have read-only access to view Region EMs data.
//                         </p>
//                         <div className="alert alert-info" role="alert">
//                             <strong>Note:</strong> As a Region EM user, you can view all data but cannot add, edit, or delete any records.
//                         </div>
//                     </div>
//                 ) : (
//                     <div>
//                         <p className="headerSubtitle">
//                             You can view, add, edit, or delete Region EMs from here
//                         </p>
//                         <p className="headerSubtitle">
//                             Note: Deleting a Region EM is irreversible. Do it at your own risk.
//                         </p>
//                         <div className='d-flex justify-content-center align-items-baseline mt-3'>
//                             <button
//                                 className={`${css.fileUploadBtn} commonBtn`}
//                                 onClick={handleAddRegionEMClick}
//                             >
//                                 <FontAwesomeIcon icon={faPlus} style={{ color: "#ffffff", marginRight: "5px" }} />
//                                 Add Region EM
//                             </button>
//                         </div>
//                     </div>
//                 )}
//             </HeaderCard>

//             <div className={css.filterBtns}>
//                 <div className='d-flex' style={{
//                     position: 'relative',
//                     justifyContent: 'end',
//                     alignItems: 'center'
//                 }}>
//                     <input
//                         type="text"
//                         value={searchQuery}
//                         placeholder="Search Region EMs"
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         className={css.searchInput}
//                     />
//                     <FontAwesomeIcon
//                         icon={faMagnifyingGlass}
//                         style={{ color: "black", position: 'absolute', right: '10px' }}
//                     />
//                 </div>
//             </div>

//             {isLoading ? (
//                 <Loader />
//             ) : (
//                 <div>
//                     <DataGrid
//                         rows={rows}
//                         columns={columns}
//                         initialState={{
//                             pagination: {
//                                 paginationModel: { pageSize: 7, page: 0 },
//                             },
//                         }}
//                         slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
//                     />
//                 </div>
//             )}

//             {/* Delete Confirmation Dialog */}
//             <Dialog
//                 open={openDeleteDialog}
//                 onClose={handleDeleteDialogClose}
//                 aria-labelledby="delete-dialog-title"
//                 aria-describedby="delete-dialog-description"
//             >
//                 <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText id="delete-dialog-description">
//                         Are you sure you want to delete this Region EM? This action is irreversible.
//                     </DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleDeleteDialogClose} color="primary">
//                         Cancel
//                     </Button>
//                     <Button onClick={handleDeleteConfirm} color="error" autoFocus>
//                         Delete
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Reinvite Confirmation Dialog */}
//             <Dialog
//                 open={openReinviteDialog}
//                 onClose={handleReinviteDialogClose}
//                 aria-labelledby="reinvite-dialog-title"
//                 aria-describedby="reinvite-dialog-description"
//             >
//                 <DialogTitle id="reinvite-dialog-title">Confirm Reinvite</DialogTitle>
//                 <DialogContent>
//                     <DialogContentText id="reinvite-dialog-description">
//                         Are you sure you want to resend the invitation email to this Region EM?
//                     </DialogContentText>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={handleReinviteDialogClose} color="primary">
//                         Cancel
//                     </Button>
//                     <Button onClick={handleReinviteConfirm} color="primary" autoFocus>
//                         Send Invitation
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </div>
//     );
// };

// export default AllRegionEM; 


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { DataGrid, GridColumnMenu, GridToolbar } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import Badge from "@mui/material/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMagnifyingGlass,
  faUserGraduate,
  faEnvelope,
  faUserCheck,
  faIdBadge,
  faFileSignature,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import SecCard from "../../components/common/SecCard";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

import { green, yellow, red, deepPurple } from "@mui/material/colors";
import { SERVER_ORIGIN } from "../../utilities/constants";
import {
  hasReadOnlyAccess,
  getDashboardPath,
} from "../../utilities/helper_functions";
import BackButton from "../../components/common/BackButton";
import css from "../../css/admin/users-page.module.css";

const AllRegionEM = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allRegionEMs, setAllRegionEMs] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);

  // Dialog states
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openReinviteDialog, setOpenReinviteDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedOnboardingStatus, setSelectedOnboardingStatus] = useState("");

  // Filter states
  const [filters, setFilters] = useState({
    region: "",
    onboardingStatus: "",
    emailStatus: "",
  });

  const navigate = useNavigate();
  const currentUserType = sessionStorage.getItem("userType");
  const userRegion = sessionStorage.getItem("region");

  console.log("currentUserType:", currentUserType);
  console.log("userRegion:", userRegion);
  // Get unique values for dropdowns
  const uniqueRegions = [
    ...new Set(allRegionEMs.map((item) => item.region).filter(Boolean)),
  ];

  // Debounce search input
  useEffect(() => {
    const handle = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      350
    );
    return () => clearTimeout(handle);
  }, [searchQuery]);

  useEffect(() => {
    async function canVisitPage() {
      setIsLoading(true);
      try {
        const currentUserType = sessionStorage.getItem("userType");
        let verifyEndpoint = "";
        let headers = {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        };

        if (currentUserType === "admin") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/admin/auth/verify-token`;
          const adminId = process.env.REACT_APP_ADMIN_ID;
          const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
          const basicAuth = btoa(`${adminId}:${adminPassword}`);
          headers.Authorization = `Basic ${basicAuth}`;
        } else if (currentUserType === "regionem") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/regionem/auth/verify-token`;
        } else {
          navigate("/login");
          return;
        }

        const response = await fetch(verifyEndpoint, {
          method: "POST",
          headers: headers,
        });

        const result = await response.json();

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate(`/login?userType=${currentUserType}`);
          } else {
            toast.error(result.statusText);
          }
        }
      } catch (err) {
        console.log(err.message);
        navigate("/login");
      }
      setIsLoading(false);
    }
    async function getAllRegionEMs() {
      setIsLoading(true);

      try {
        let regionQuery = "";

        if (currentUserType === "regionem" && userRegion) {
          regionQuery = `&region=${userRegion}`;
        }
        const response = await fetch(
          `${SERVER_ORIGIN}/api/regionem/auth/all?page=${page}&limit=${limit}&search=${debouncedSearch}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
          }${regionQuery}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
          }
        );

        const result = await response.json();
        setIsLoading(false);

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/admin/login");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          setAllRegionEMs(result.filteredRegionEMs);
          setTotalPages(result.totalPages);
        }
      } catch (err) {
        setIsLoading(false);
        toast.error("Failed to fetch Regional Mentor");
      }
    }
    canVisitPage();

    getAllRegionEMs();
  }, [page, sortType, debouncedSearch, navigate, limit]);

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  // Apply filters to data
  const filteredRegionEMs = allRegionEMs.filter((regionEM) => {
    return (
      (!filters.region || regionEM.region === filters.region) &&
      (!filters.onboardingStatus ||
        regionEM.onboardingSatus === filters.onboardingStatus) &&
      (!filters.emailStatus || regionEM.emailSentStatus === filters.emailStatus)
    );
  });

  // Clear all filters
  const clearAllFilters = () => {
    setFilters({
      region: "",
      onboardingStatus: "",
      emailStatus: "",
    });
    setSearchQuery("");
  };

  // Calculate statistics
  const getStatistics = () => {
    const total = filteredRegionEMs.length;
    const onboarded = filteredRegionEMs.filter(
      (em) => em.onboardingSatus === "onboarded"
    ).length;
    const invited = filteredRegionEMs.filter(
      (em) => em.onboardingSatus === "invited"
    ).length;
    const pending = filteredRegionEMs.filter(
      (em) => em.onboardingSatus === "pending"
    ).length;
    const emailSent = filteredRegionEMs.filter(
      (em) => em.emailSentStatus === "sent"
    ).length;
    const emailNotSent = filteredRegionEMs.filter(
      (em) => em.emailSentStatus === "not sent"
    ).length;

    return {
      total,
      onboarded,
      invited,
      pending,
      emailSent,
      emailNotSent,
    };
  };

  const stats = getStatistics();

  const renderOnboardingStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = deepPurple[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            borderRadius: "8px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const renderEmailStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "sent":
        statusColor = green[500];
        statusText = "Sent";
        textColor = "white";
        break;
      case "not sent":
        statusColor = red[500];
        statusText = "Not Sent";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            borderRadius: "8px",
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  // Dialog handlers
  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setOpenDeleteDialog(true);
  };

  const handleReinviteClick = (id, onboardingStatus) => {
    if (onboardingStatus === "onboarded") {
      toast.error("Cannot reinvite an already onboarded user");
      return;
    }
    setSelectedId(id);
    setSelectedOnboardingStatus(onboardingStatus);
    setOpenReinviteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setOpenDeleteDialog(false);
    setSelectedId(null);
  };

  const handleReinviteDialogClose = () => {
    setOpenReinviteDialog(false);
    setSelectedId(null);
    setSelectedOnboardingStatus("");
  };

  const handleDeleteConfirm = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/regionem/auth/dlt/${selectedId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );

      const result = await response.json();
      if (response.status === 200) {
        toast.success("Regional Mentor deleted successfully");
        // Refresh the list
        window.location.reload();
      } else {
        toast.error(result.statusText || "Failed to delete Region EM");
      }
    } catch (err) {
      toast.error("Error deleting Regional Mentor");
    }
    handleDeleteDialogClose();
  };

  const handleReinviteConfirm = async () => {
    try {
      const response = await fetch(
        `${SERVER_ORIGIN}/api/regionem/auth/reinvite/${selectedId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
          },
        }
      );

      const result = await response.json();
      if (response.status === 200) {
        toast.success("Invitation email sent successfully");
        // Refresh the list to update status
        window.location.reload();
      } else {
        toast.error(result.statusText || "Failed to send invitation");
      }
    } catch (err) {
      toast.error("Error sending invitation");
    }
    handleReinviteDialogClose();
  };

  // Elevate on hover component for cards
  const ElevateOnHover = ({ children }) => {
    const [hovered, setHovered] = useState(false);
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          borderRadius: 12,
          background: "#ffffff",
          transition: "box-shadow 200ms ease, transform 200ms ease",
          boxShadow: hovered
            ? "0 8px 24px rgba(16,24,40,.12)"
            : "0 1px 3px rgba(16,24,40,.06)",
          transform: hovered ? "translateY(-2px)" : "none",
        }}
      >
        {children}
      </div>
    );
  };

  // Stat Card Component
  const StatCard = ({ title, value, icon, gradient }) => (
    <ElevateOnHover>
      <div className={css.dashboardCard} style={{ overflow: "hidden" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
          }}
        >
          <h3
            className={css.cardTitle}
            style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}
          >
            {title}
          </h3>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: gradient,
              color: "#fff",
            }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div
          className={css.cardContent}
          style={{ paddingTop: 0, padding: "0 16px 16px" }}
        >
          <div
            style={{ fontSize: "24px", fontWeight: "600", color: "#1f2937" }}
          >
            {value}
          </div>
        </div>
      </div>
    </ElevateOnHover>
  );

  const rows = filteredRegionEMs.map((regionEM, idx) => ({
    ...regionEM,
    id: idx + 1,
  }));

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "name",
      headerName: "Name",
      width: 170,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
    },
    {
      field: "region",
      headerName: "Region",
      width: 150,
    },
    {
      field: "mobile_no",
      headerName: "Mobile Number",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    {
      field: "regionEMfor",
      headerName: "Regional Mentor For",
      width: 150,
    },
    // {
    //   field: "emailSentStatus",
    //   headerName: "Email Status",
    //   width: 130,
    //   renderCell: renderEmailStatus,
    // },
    {
      field: "onboardingSatus",
      headerName: "Onboarding Status",
      width: 160,
      renderCell: renderOnboardingStatus,
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      align: "center",
      width: 140,
      valueGetter: (params) => params.row.updatedAt || params.row.createdAt || null,
      valueFormatter: (params) => {
        if (!params.value) return "-";
        const d = new Date(params.value);
        return d.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      renderCell: (params) => (
        <span style={{ whiteSpace: "normal", lineHeight: 1.3 }}>
          {params.formattedValue || params.value || "-"}
        </span>
      ),
    },
    {
      field: "editDetails",
      headerName: "Edit",
      type: "actions",
      width: 120,
      align: "center",
      renderCell: (params) => {
        const isReadOnly = hasReadOnlyAccess();

        if (isReadOnly) {
          return (
            <div className="d-flex justify-content-center">
              <span className="badge bg-secondary">View Only</span>
            </div>
          );
        }
        return (
          <button
            className={css.viewBtn}
            onClick={() =>
              navigate(
                `/region-em/add?edit=true&id=${encodeURIComponent(
                  params.row._id
                )}`
              )
            }
          >
            Edit
          </button>
        );
      },
    },
    {
      headerName: "Actions",
      width: 200,
      renderCell: (params) => {
        const isOnboarded = params.row.onboardingSatus === "onboarded";
        const isReadOnly = hasReadOnlyAccess();

        if (isReadOnly) {
          return (
            <div className="d-flex justify-content-center">
              <span className="badge bg-secondary">View Only</span>
            </div>
          );
        }

        return (
          <div className="d-flex gap-2">
            {!isOnboarded && (
              <button
                className="btn btn-sm btn-warning"
                onClick={() =>
                  handleReinviteClick(
                    params.row._id,
                    params.row.onboardingSatus
                  )
                }
                style={{
                  color: "white",
                  background: "linear-gradient(135deg,#f59e0b,#f97316)",
                  border: "none",
                  borderRadius: "6px",
                  padding: "4px 12px",
                  fontSize: "12px",
                }}
              >
                Reinvite
              </button>
            )}
            <button
              className="btn btn-sm btn-danger"
              onClick={() => handleDeleteClick(params.row._id)}
              style={{
                background: "linear-gradient(135deg,#ef4444,#dc2626)",
                border: "none",
                borderRadius: "6px",
                padding: "4px 12px",
                fontSize: "12px",
              }}
            >
              Delete
            </button>
          </div>
        );
      },
    },
  ];

  function handleAddRegionEMClick() {
    navigate("/region-em/add");
  }

  function CustomColumnMenu(props) {
    return <GridColumnMenu {...props} slotProps={{}} />;
  }

  return (
    <div className={css.outerDiv}>
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>

      {hasReadOnlyAccess() && (
        <div className={css.readOnlyAlert}>
          <div className="alert alert-info" role="alert">
            <strong>Read-Only Access:</strong> You can view all Regional Mentor
            Data data but cannot add, edit, or delete any records.
          </div>
        </div>
      )}

      {/* Dashboard Stats Section */}
      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>Regional Mentor Data</div>

              <div className={css.headerRight}>
                {!hasReadOnlyAccess() && (
                  <button
                    className={css.addBtn}
                    onClick={handleAddRegionEMClick}
                  >
                    <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                    Add Regional Mentor
                  </button>
                )}
              </div>
            </div>
          </Row>
        </SecCard>
      </div>

      {/* Search and Filters Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search</label>
            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search here ..."
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              {/* <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              /> */}
            </div>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Region</label>
            <select
              value={filters.region}
              onChange={(e) => handleFilterChange("region", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Regions</option>
              {uniqueRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Onboarding Status</label>
            <select
              value={filters.onboardingStatus}
              onChange={(e) =>
                handleFilterChange("onboardingStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="onboarded">Onboarded</option>
              <option value="invited">Invited</option>
              <option value="pending">Pending</option>
            </select>
          </div>

          {/* <div className={css.filterGroup}>
            <label className={css.filterLabel}>Email Status</label>
            <select
              value={filters.emailStatus}
              onChange={(e) =>
                handleFilterChange("emailStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="sent">Sent</option>
              <option value="not sent">Not Sent</option>
            </select>
          </div> */}

          <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
            Clear All
          </button>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
        </div>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleDeleteDialogClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this Regional Mentor? This action is
            irreversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reinvite Confirmation Dialog */}
      <Dialog
        open={openReinviteDialog}
        onClose={handleReinviteDialogClose}
        aria-labelledby="reinvite-dialog-title"
        aria-describedby="reinvite-dialog-description"
      >
        <DialogTitle id="reinvite-dialog-title">Confirm Reinvite</DialogTitle>
        <DialogContent>
          <DialogContentText id="reinvite-dialog-description">
            Are you sure you want to resend the invitation email to this Region
            EM?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReinviteDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleReinviteConfirm} color="primary" autoFocus>
            Send Invitation
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AllRegionEM;